var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('Header'),_c('v-main',[_c('v-container',{staticClass:"pa-0",staticStyle:{"max-width":"1200px"},attrs:{"align-center":""}},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }